import React from 'react';
import { Component } from "react";
import { API_URL } from '../urls';
require('odatajs');

class PropertiesView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      pending: true,
      data: null,
      type_id: props.type_id,
      module_id: props.module_id,
    };
  }

  componentDidMount() {
    let token = localStorage.getItem('_TOKEN_AUTH');
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json', Authorization: "Bearer " + token };
    var request = {
        requestUri: API_URL + "Modules(" + this.state.module_id + ")/Types(" + this.state.type_id + ")/?$expand=IVySoft.SiteBuilder.App.TypeWithProperties/Properties",
        method: 'GET',
        headers: headers
    };
    window.odatajs.oData.request(
        request,
        (data, response) => {
          	this.setState({
	            pending: false,
        	    data
	        });
            },
            (error) => {
                if(error.response.statusCode === 401){
                  window.location.href = "/login";
                }
          	this.setState({
	            pending: false,
        	    error
	        });
            }
        );
    }
    render() { 
	const { error, pending, data } = this.state;
	if (error) {
      		return <div>Error: {error.message}</div>;
	} else if (pending) {
		return <div>Loading...</div>;
	} else {
	        return (
<div><div id='propertiesLabel'>Properties:</div>
{data.Properties.map((data, index) => (
<ul>
<li>
<div >{data.Name}({data.Type},{data.Multiplicity})</div>
</li>
</ul>
))}
</div>
		);
	}
    }
}
 
export default PropertiesView;